import { Typography } from '../../../../../shared/ui/typography/typography';
import { Button } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: center;
`;

export const Title = styled('div')`
    position: relative;
    display: flex;
    width: 100%;
    height: 40px;
    align-items: center;
`;

export const BackButton = styled(Button)`
    position: absolute !important;
    display: block;
    margin: 0;
    top: 0;
    left: 0;
    border: none !important;

    .rf-button__text {
        margin: 0 !important;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`;

export const TitleText = styled(Typography)`
    width: 100%;
    text-align: center;
`;

export const Description = styled(Typography)`
    margin-top: 40px;
`;

export const FormBox = styled('form')<{ isVisibleCaptcha: boolean }>`
    .smart-captcha {
        width: 100%;

        ${({ isVisibleCaptcha }) =>
            !isVisibleCaptcha &&
            `display: none;
						height: 0px !important;
					`}
    }

    display: flex;
    width: 100%;
    margin-top: 20px;
    flex-direction: column;
    align-items: center;
    gap: 40px;
`;

export const Controls = styled('div')`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 20px;
`;

export const ButtonGroup = styled('div')`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 16px;
`;

// Для сохранения ширины при отображении лоудера
export const SubmitButton = styled(Button)`
    min-width: 140px !important;
`;
